import { parseISO, format } from 'date-fns';
import { useNextOrderV2 } from '@hungryroot/orders';

export const usePairingInventoryParams = () => {
  const { order: nextEditableOrder } = useNextOrderV2();

  const inventoryParams = nextEditableOrder && {
    origin: nextEditableOrder.origin,
    inventory_date: format(
      parseISO(nextEditableOrder.cutoff_date),
      'yyyy-MM-dd'
    ),
  };

  return inventoryParams;
};
